import { useMatchMedia } from './useMatchMedia';
import { MOBILE_VIEWPORT_QUERY } from '../constants/breakpoints';

export function useIsMobileViewport(): boolean {
  return useMatchMedia(MOBILE_VIEWPORT_QUERY);
}
